import { TreeNode } from './tree-node';

export interface TreeState<T> {
  nodes: {
    [path: string]: TreeNode<T>[];
  }
}
